export const productcardtheme = {
       maincard :{
         Width: "fit-content",
         maxWidth: "320px",
        cursor: "pointer",
        minHeight: "340px",
        padding: "10px",
        // backgroundColor: "pink"
        // fontFamily: "RobotoLR"
       },
       maincardisShown :{
         Width: "fit-content",
         maxWidth: "320px",
        cursor: "pointer",
        minHeight: "340px",
        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
        padding: "10px",
        borderRadius: "5px",
      //   zIndex: "100",
        
      //   position : "relative"
        // backgroundColor: "pink"
        // fontFamily: "RobotoLR"
       },
       prodimg:{
        width: "100%",
        margin: "auto",
        marginBottom: "10px"

       },
       title:{
          textAlign: "left",
          color: "#282828",
          lineHeight: "1.3",
          width: "92%",
          margin: "0px 0px 10px",
          position: "relative",
          fontWeight: "400",
       },
       price:{
        textAlign: "left",
        color: "#575757",
        fontSize: "100%",
        fontWeight: "600",
     },
     clubrow:{
         display: "flex",
         alignItems: "left",
         marginLeft: "5px",
         
     }
}